import { reportError } from 'utils/error'

export enum HeapEventType {
  Registration = 'Registration',
  CommandLine = 'CommandLine',
  AccessBlocked = 'AccessBlocked',
  Onboarding = 'Onboarding',
  SideStacking = 'SideStacking',
  ImportContacts = 'ImportContacts',
  SeoAnalysis = 'SeoAnalysis',
  ImportDocs = 'ImportDocs',
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  Payment = 'Payment',
  NewRegistration = 'NewRegistration',
  NewOnboarding = 'NewOnboarding',
  VisualStylesForExistingUsers = 'VisualStylesForExistingUsers',
  NextGenOptIn = 'NextGenOptIn',
}

export type HeapEventActions =
  | 'start'
  | 'end'
  | 'success'
  | 'failed'
  | 'skip_invites'
  | 'cancel_workspace_creation'
  | 'command_line_opened'
  | 'command_line_run'
  | 'doc_access_blocked'
  | 'google_contact_import_started'
  | 'google_contact_import_triage_started'
  | 'google_contact_import_finished'
  | 'google_docs_import_started'
  | 'google_docs_import_triage_started'
  | 'google_docs_import_finished'
  | 'handbook_access_blocked'
  | 'enter-email-google-complete'
  | 'verify-email-with-code-complete'
  | 'verify-email-with-code-failed'
  | 'create-account-complete'
  | 'create-account-failed'
  | 'select-role-complete'
  | 'select-use-case-complete'
  | 'select-use-case-failed'
  | 'invite-team-complete'
  | 'invite-team-failed'
  | 'onboarding-start'
  | 'onboarding-skip'
  | 'onboarding-finish'
  | 'onboarding-async'
  | 'onboarding-draft'
  | 'onboarding-review'
  | 'onboarding-organize'
  | 'start-drag'
  | 'drop'
  | 'select-node'
  | 'seo-analysis'
  | 'skip-secret-identity'
  | 'download-secret-identity'
  | 'share-secret-identity'
  | 'payment-failed-early'
  | 'payment-failed-late'
  | 'select-discovery-source-complete'
  | 'select-business-type-complete'
  | 'nextgen-opt-in-start'
  | 'nextgen-opt-in-disclaimer'
  | 'nextgen-opt-in-goals'
  | 'nextgen-opt-in-content-modification'
  | 'nextgen-opt-in-strategy'
  | 'nextgen-opt-in-generation-timing'
  | 'nextgen-opt-in-generate-now'
  | 'nextgen-opt-in-wait'
  | string

export type HeapEventProperties = {
  action: HeapEventActions
  type?: string
  ab_test_variant?: 'A' | 'B'
  is_ios_native?: boolean

  has_custom_fonts?: boolean
  visual_style_id?: number
  font_pairing_id?: number
  brand_kit_id?: number
  media_files_count?: number
  recommended_visual_style_ids?: number[]
  did_manually_change_visual_style?: boolean
  recommended_font_pairing_ids?: number[]
  did_manually_change_font_pairing?: boolean
  selected_media_file_id?: number
  animated_images_opt_in?: boolean
}

export const trackEventInHeap = (eventType: HeapEventType, properties: HeapEventProperties) => {
  try {
    const isIOSNative = navigator.userAgent.includes('blaze-ios')
    const enhancedProperties = {
      ...properties,
      ...(isIOSNative && { is_ios_native: isIOSNative }),
    }
    window.heap?.track(eventType, enhancedProperties)
  } catch (e) {
    reportError(e, {
      severity: 'error',
      metaData: { properties },
    })
  }
}
